import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuModule } from 'ngx-zcs-blocks';

import { REFRESH_OPTIONS, RefreshService } from '../../services';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    MenuModule,
  ],
  selector: 'customer-refresh-selector',
  templateUrl: './refresh-selector.component.html',
  styleUrls: ['./refresh-selector.component.scss'],
})
export class RefreshSelectorComponent {
  REFRESH_OPTIONS = REFRESH_OPTIONS;

  constructor(
    readonly refreshService: RefreshService,
  ) {}
}
